module.exports = __webpack_public_path__ + "img/service-CRM2.d3ff03f9.svg";